export enum ProjectReportCoverContactsEnum {
  OFFICE = 'office',
  ORGANIZATION = 'organization',
}
